import { render, staticRenderFns } from "./ModularDetailsSectionHeader.vue?vue&type=template&id=7eb0e3cc"
import script from "./ModularDetailsSectionHeader.vue?vue&type=script&lang=js"
export * from "./ModularDetailsSectionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports